var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoCoin41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "url(#paint0_linear_18290_74571)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7992 19.1476H20.8565V23.8783H27.2191C26.3685 26.1423 24.293 27.5278 21.1287 27.5278C16.5013 27.5278 13.6432 24.588 13.6432 20.5668C13.6432 16.4105 16.6374 13.4706 20.6523 13.4706C23.3403 13.4706 25.4839 14.6871 26.4706 16.2415L31.098 13.6058C29.0905 10.4294 25.2457 8.19922 20.6864 8.19922C13.6772 8.19922 8.19922 13.6734 8.19922 20.533C8.19922 27.325 13.5752 32.7992 21.0606 32.7992C27.7295 32.7992 32.7992 28.4064 32.7992 21.175V19.1476Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18290_74571",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E9EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoCoin41);
export default __webpack_public_path__ + "static/media/goCoin41.755bac9622e5e366623c34b0e470d9af.svg";
export { ForwardRef as ReactComponent };